import React, {useContext, useEffect, useRef, useState} from 'react';
import {useFetch} from "../../layout/hooks/useFetch";
import {DataTable, DataTableExpandedRows, DataTableValueArray} from "primereact/datatable";
import callToast, {formattedDateTime, tablePerPageOptions} from "../../utils/helper";
import {Column} from "primereact/column";
import {paginationTemplate} from "../../utils/paginationTemplate";
import {baseUrl} from "../../utils/webInfo";
import {Button} from "primereact/button";
import LocationModal from "../../Component/LocationModal";
import ActionTemplate from "../../Component/ActionTemplate";
import {LayoutContext} from "../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {useNavigate} from "react-router-dom";
import SmallHeader from "../../Component/SmallHeader";
import {Image} from "primereact/image";
import {Dropdown} from "primereact/dropdown";
import {IidName} from "../../interfaces/interfaces";
import PageHeading from "../../Component/PageHeading";


const Order = () => {
    const {accessToken} = useContext(LayoutContext);
    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
    const navigate = useNavigate();
    const toast = useRef<Toast | null>(null);
    const [orderData, setOrderData] = useState<any>([]);
    const deleteRef = useRef<number>(0);
    const [limitData, setLimitData] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0)

    const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);
    const [update, setUpdate] = useState<boolean>(false);
    const [orderStatusData, setOrderStatusData] = useState<IidName[]>([]);
    const [visibleLocationModal, setVisibleLocationModal] = useState(false);
    const [position, setPosition] = useState<{ [key: string]: string } | null>(null)


    // Set Current Page
    useEffect(() => {
        let pages = Math.ceil(pageNumber / limitData);
        setCurrentPage(pages)
    }, [pageNumber, limitData]);
    const {data: orders, notFound, loading, totalData} = useFetch(`/api/order?page=${currentPage}&size=10&sort=-id`,[update]);
    // order data
    useEffect(() => {
        if (notFound) {
            setOrderData([])
        }
        if (orders) {
            setOrderData(orders);
        }
    }, [orders, notFound]);
    // Fetch order status
    useEffect(() => {
        if (!accessToken) return;

        const getData = async () => {
            try {
                const res = await fetch(`${baseUrl?.url}/api/order_status?page=0&size=100`, {
                    method: "GET",
                    headers: {Authorization: `Bearer ${accessToken}`}
                });
                if (res.ok && res.status !== 204) {
                    const data = await res.json();
                    const option = data?.data?.items?.map((d: any) => ({
                        id: d.id, name: d.name
                    }));
                    setOrderStatusData(option);
                }
            } catch (e) {
                console.error(e);
            }
        };
        getData().then();
    }, [accessToken]);

    // Handle Status Change
    const handleChangeStatus = async (ids: number[], status: number) => {
        try {
            setStatusUpdateLoading(true)
            // const res = await fetch(`${baseUrl.url}/api/client_info_status/${status.toString()}`, {
            const res = await fetch(`${baseUrl.url}/api/order_status/${ids}?order_status_id=${status}`, {
                method: "PUT",
                headers: {
                    "Content-type": "Application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
                // body: JSON.stringify(ids)
            });

            if (res.status === 304) {
                callToast(toast, "warn", "No data changed")
                return
            }
            if (res.ok) {
                callToast(toast, true, `Client status updated successfully`)
                setUpdatedId(null)
                setUpdate(!update)

            } else {
                const resData = await res.json();
                const {errors} = resData
                callToast(toast, false, errors[0]);
            }
        } catch (error: any) {
            callToast(toast, false, error?.message)
        } finally {
            setStatusUpdateLoading(false)
        }
    }


    const rowExpansionBodyTemplate = (data: any) => {
        const {products, note} = data;

        console.log("pro=====>", products);
        return (
            <div className={"my-3"}>
                <SmallHeader text={'Note'}/>
                <p>{note}</p>
                <SmallHeader text={'Products'}/>
                {
                    products?.length ? <div className="pt-2 w-8">
                        {/*{*/}
                        {/*    products.map((item: any, index: number) => {*/}
                        {/*        const {product} = item;*/}
                        {/*        return (*/}
                        {/*            <div key={index} className="mb-3">*/}
                        {/*                <div className="flex gap-2 w-full  border border-round border-primary">*/}
                        {/*                    {*/}
                        {/*                        product.imageURL ?*/}
                        {/*                            <Image src={`${baseUrl.url}/${product?.imageURL}`} alt="Product"*/}
                        {/*                                   width="60"/> :*/}
                        {/*                            <Image src="/default.png" alt="Product" width="60"/>*/}
                        {/*                    }*/}
                        {/*                    <div>*/}
                        {/*                        <div className="flex-1">*/}
                        {/*                            <p className="font-semibold m-0">{product?.brandName}</p>*/}
                        {/*                            <p className="m-0 text-sm text-color-secondary">{product?.genericName}</p>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*    })*/}
                        {/*}*/}

                        <DataTable value={products}>
                            <Column  header="Product" body={(data)=>{
                                console.log("Data====>>>>", data)
                                const {product}=data

                                return (
                                    <div className="flex gap-2 align-items-center">
                                        <div>
                                            {
                                                data?.product?.imageURL ?
                                                    <Image src={`${baseUrl.url}/${product?.imageURL}`} alt="Product"
                                                           width="60"/> :
                                                    <Image src="/default.png" alt="Product" width="60"/>
                                            }
                                        </div>

                                        <div>
                                            <p className="font-semibold m-0">{product?.brandName}</p>
                                            <p className="m-0 text-sm text-color-secondary max-w-20rem">{product?.genericName}</p>
                                        </div>
                                    </div>
                                )
                            }} />
                            <Column field="quantity" header="Quantity"/>
                            <Column field="unit_price" header="Unit Price"/>
                            <Column field="total_price" header="Total Price"/>
                        </DataTable>
                    </div> : ""
                }

            </div>
        );
    };


    return (
        <div className="card">
            <PageHeading title={"Order"}/>

            <DataTable
                value={orderData}
                dataKey="id"
                className="datatable-responsive myTable"
                emptyMessage="No board found."
                // filterDisplay={"row"}
                rowHover={true}
                paginator={orderData?.length > 0}
                loading={loading}
                lazy
                first={pageNumber}
                rows={limitData}
                totalRecords={totalData}
                onPage={(e) => {
                    setPageNumber(e.first);
                    setLimitData(e.rows);
                }}
                rowsPerPageOptions={tablePerPageOptions}
                paginatorTemplate={paginationTemplate}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                    setExpandedRows(e.data);
                }}
                rowExpansionTemplate={rowExpansionBodyTemplate}
            >
                <Column expander style={{width: "5rem"}}/>
                <Column
                    // className={"w-10rem"}
                    header={"Order No"}
                    field={"order_no"}
                    bodyClassName={'white-space-nowrap'}
                    body={(data: any) => {
                        return (<div>
                            <p className="m-0">{data.order_no}</p>
                            <p className="m-0 text-sm">{data?.updated_at ? formattedDateTime(data?.updated_at) : ""}</p>
                        </div>)
                    }}
                />

                <Column
                    // className={"w-13rem"}
                    headerClassName={'white-space-nowrap'}
                    header={"Party ID"}
                    body={(data: any) => {
                        return (
                            <div>
                                <p className="m-0">{data?.party_id || 'N/A'}</p>
                                <p className="m-0">{data?.reference_user?.unique_code}</p>
                            </div>
                        )
                    }}
                />

                <Column
                    header={"Delivery Address"}
                    // className={''}
                    bodyClassName='white-space-nowrap  '
                    body={(data) => {
                        const {latitude, longitude, address, upazila} = data
                        return (
                            <div className="flex gap-2 align-items-center ">
                                <div className={""}>
                                    <Button
                                        onClick={() => {
                                            setVisibleLocationModal(true)
                                            setPosition({
                                                latitude, longitude
                                            })
                                        }}
                                        icon={"pi pi-map-marker"} text rounded severity={"secondary"}
                                        className={"w-2rem h-2rem"}
                                    />
                                </div>

                                <div>
                                    <p className="text-sm m-0">{address} </p>
                                    <p className="text-sm m-0">{upazila ? `${upazila?.name}` : ""} </p>
                                </div>
                            </div>
                        )
                    }}
                />

                <Column
                    className={"w-15rem"}
                    header={"Depot"}
                    bodyClassName={'white-space-nowrap'}
                    body={(data) => {
                        const {depot} = data;
                        return (<div>
                            <p className="m-0 text-sm">{depot?.name}</p>
                            <p className="m-0 text-sm">{depot?.address}</p>
                        </div>)
                    }}
                />

                <Column
                    // className={"w-20rem"}
                    header={"Referred By"}
                    headerClassName={'white-space-nowrap'}
                    bodyClassName={'white-space-nowrap'}
                    body={(data) => {
                        return (<div>
                            <p className="m-0">{data.reference_user?.name || 'N/A'}</p>
                            <p className="m-0">{data.reference_user?.system_employee_id}</p>
                        </div>)
                    }}
                    // field={"reference_user.name"}
                />

                <Column
                    // className={"w-13rem"}
                    headerClassName={'white-space-nowrap'}
                    bodyClassName={'white-space-nowrap'}
                    header={"Chemcare User"}
                    body={(data) => {
                        return (<div className="flex gap-2 align-items-center">
                            <div>
                                {
                                    data?.ordered_by.imageURL ?
                                        <img src={`${baseUrl?.url}${data.ordered_by?.imageURL}`} alt={"Employee"}
                                             style={{width: "32px", height: "32px"}} className={"border-circle"}/>
                                        : ""
                                }
                            </div>

                            <div>
                                <p className="m-0">{data.ordered_by?.name}</p>
                            </div>
                        </div>)
                    }}
                />


                <Column
                    // className={"w-8rem"}
                    header={"Total"}
                    field={"total_price"}
                />

                <Column
                    // className={"w-8rem"}
                    header={"Discount"}
                    field={"discount"}
                />
                <Column
                    headerClassName={'white-space-nowrap'}
                    header={"Delivery Charges"}
                    field={"delivery_fee"}
                />

                <Column
                    header={"Promo"}
                    field={"promo_code"}
                />

                <Column
                    className="white-space-nowrap"
                    header={"Payment Type"}
                    field={"payment_type.name"}
                />

                <Column header={"Order Status"}
                        headerClassName={'white-space-nowrap'}
                        body={(data) => {
                            const {order_status, id, order_status_id} = data
                            return (
                                <div onClick={(event) => {
                                    event.preventDefault()
                                }}
                                     style={{zIndex: 1000}}
                                >
                                    {
                                        updatedId === id ? <div className={"flex align-items-center gap-1 w-full"}>
                                                <Dropdown value={orderStatusData[order_status]}
                                                          onChange={(e) => {
                                                              handleChangeStatus([id], e?.value?.id).then()
                                                          }}
                                                          options={orderStatusData} optionLabel="name"
                                                          placeholder="Select Status" className="w-15rem xl:w-12rem"
                                                          disabled={statusUpdateLoading}/>

                                                <Button style={{width: "24px", height: "24px"}} icon={"pi pi-times"}
                                                        severity={"danger"} rounded
                                                        onClick={() => {
                                                            setUpdatedId(null)
                                                        }}
                                                        disabled={statusUpdateLoading}
                                                />
                                            </div>
                                            :
                                            <div className={"w-full"}>
                                                                                        <span
                                                                                            onClick={(event) => {
                                                                                                event.preventDefault()
                                                                                                setUpdatedId(id)
                                                                                            }}
                                                                                            className={`custom-badge ${order_status_id === 1 ? "pending"
                                                                                                : order_status_id === 2 ? "in-progress"
                                                                                                    : order_status_id === 3 ? "in-progress"
                                                                                                        : order_status_id === 4 ? "new" :
                                                                                                            order_status_id === 5 ? "approved" :
                                                                                                                "cancelled"}`}>{order_status?.name}</span>

                                            </div>
                                    }
                                </div>
                            )
                        }}
                        showFilterMenu={false}
                    // filter
                    // filterElement={
                    //     <Dropdown value={filterApproval}
                    //               onChange={(e: DropdownChangeEvent) => {
                    //                   setFilterApproval(e.value)
                    //                   setCurrentPage(0)
                    //               }}
                    //               filter
                    //               showFilterClear
                    //               options={[
                    //                   {
                    //                       id: 0,
                    //                       name: 'Pending'
                    //                   },
                    //                   {
                    //                       id: 1,
                    //                       name: 'Approved'
                    //                   },
                    //                   {
                    //                       id: 2,
                    //                       name: 'Rejected'
                    //                   }
                    //               ]} optionLabel="name"
                    //               placeholder="Filter by Approval" className="w-13rem" showClear/>
                    // }
                />

                <Column
                    header={"Action"}
                    headerClassName={"flex justify-content-end w-full"}
                    body={(data) => {
                        const {id} = data
                        return <ActionTemplate
                            id={id}
                            // name={"order information"}
                            // accept={accept} deleteRef={deleteRef}
                            editFunction={() => {
                                navigate(`${id}`)
                            }}
                        />
                    }}
                ></Column>
            </DataTable>


            {/*    Location Modal*/}
            <LocationModal visible={visibleLocationModal} setVisible={setVisibleLocationModal} position={position}
                           setPosition={setPosition}/>
        </div>
    );
};

export default Order;